import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import { useLocation } from "react-router";
import isAdminAuthenticated from "../admin/auth/helper";
import LoadingBar from "./loadingwithstyle/loadingbar";
import signoutHandler from "../admin/auth/adminsignout";
import AOS from "aos";
import "aos/dist/aos.css";

const CommonComponent = ({ children, isLoading }) => {
  const location = useLocation();

  return (
    <div className="container-fluid m-0 p-0">
      {<NavigationBarSection isLoading={isLoading} />}
      {location.pathname === "/" && <ConnectWithMe />}

      {children}

      {location.pathname !== "/" && !isAdminAuthenticated() && <Footer />}
    </div>
  );
};

const NavigationBarSection = ({ isLoading }) => {
  const [isOpenMenu, setisOpenMenu] = useState(false);

  useEffect(() => {
    AOS.init();
  });

  const focusedNavBarClass = (path) => {
    if (window.location.pathname === path) {
      return "nav-link text-center active";
    } else {
      return "nav-link text-center";
    }
  };

  return (
    <div
      className="sticky-top"
      data-aos="fade-down"
      data-aos-duration="500"
      data-aos-delay="500"
    >
      <LoadingBar isLoading={isLoading} />
      <nav className="navbar navbar-expand-lg navbar-light top-nav-bar">
        <div className="container-fluid">
          <Link className="navbar-brand " to="/">
            <div className="row w-100 px-10 py-6">
              <div>
                <img
                  src={logo}
                  alt="Portfolio Logo"
                  width="140px"
                  className="img-fluid"
                />
              </div>
 
            </div>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ border: "none" }}
            onClick={() => {
              setisOpenMenu(!isOpenMenu);

              dataAOSremoval();
            }}
          >
            {isOpenMenu ? (
              <img
                src="https://img.icons8.com/external-becris-lineal-becris/64/000000/external-cancel-mintab-for-ios-becris-lineal-becris.png"
                alt="close menu"
                width="30"
              />
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNavAltMarkup"
          >
            <div className="navbar-nav fw-bold">
              {!isAdminAuthenticated() && (
                <Link
                  className={focusedNavBarClass("/")}
                  aria-current="page"
                  to="/"
                >
                  Home
                </Link>
              )}
              {!isAdminAuthenticated() && (
                <Link className={focusedNavBarClass("/skill")} to="/skill">
                  Skills
                </Link>
              )}

              {!isAdminAuthenticated() && (
                <Link
                  className={focusedNavBarClass("/experience")}
                  to="/experience"
                >
                  Experience
                </Link>
              )}

              {!isAdminAuthenticated() && (
                <Link className={focusedNavBarClass("/project")} to="/project">
                  Projects
                </Link>
              )}


              {!isAdminAuthenticated() && (
                <Link
                  className={focusedNavBarClass("/education")}
                  to="/education"
                >
                  Education
                </Link>
              )}
              {/* {!isAdminAuthenticated() && (
                <Link className={focusedNavBarClass("/contact")} to="/contact">
                  Contact
                </Link>
              )} */}
              {isAdminAuthenticated() && (
                <Link
                  className={focusedNavBarClass(
                    "/admin/certificate-management"
                  )}
                  to="/admin/certificate-management"
                >
                  Certificate Management
                </Link>
              )}
              {isAdminAuthenticated() && (
                <Link
                  className={focusedNavBarClass("/admin/project-management")}
                  to="/admin/project-management"
                >
                  Project Management
                </Link>
              )}
              {isAdminAuthenticated() && (
                <span
                  className={focusedNavBarClass("/signout")}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    signoutHandler();
                  }}
                >
                  Signout
                </span>
              )}
              {!isAdminAuthenticated() && (
                <Link className={focusedNavBarClass("/extras")} to="/extras">
                  Music
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

const ConnectWithMe = () => (
  <ul
    className="list-unstyled position-absolute social-links"
    data-aos="fade-right"
    data-aos-duration="2000"
    data-aos-delay="1400"
  >
    <div className="social-media-container" rel="noreferrer">
      <a
        href="https://www.facebook.com/iamkabishb"
        target="_blank"
        className="social-media-container-item fb-hover mb-5"
        rel="noreferrer"
      >
        facebook
      </a>
      <a
        href="https://www.instagram.com/iamkabishb/"
        target="_blank"
        className="social-media-container-item insta-hover mb-5"
        rel="noreferrer"
      >
        instagram
      </a>
      <a
        href="https://www.linkedin.com/in/kabish-bhattarai-9ab669190/"
        target="_blank"
        className="social-media-container-item linkedin-hover mb-5"
        rel="noreferrer"
      >
        linkedIn
      </a>
      <a
        href="https://github.com/kabishbrt"
        target="_blank"
        className="social-media-container-item github-hover mb-5"
        rel="noreferrer"
      >
        github
      </a>
      <a
        href="https://open.spotify.com/artist/0H3XFhtRlS4iLcbdprk6Xu"
        target="_blank"
        className="social-media-container-item spotify-hover mb-5"
        rel="noreferrer"
      >
        spotify
      </a>
      <a
        href="https://www.youtube.com/channel/UCA_oIWOFu3x7LywkNdEa0vQ"
        target="_blank"
        className="social-media-container-item youtube-hover mb-5"
        rel="noreferrer"
      >
        youtube
      </a>
    </div>
  </ul>
);

const socialMediaInformation = [
  {
    icon: "fab fa-spotify fa-2x",
    link: "https://open.spotify.com/artist/0H3XFhtRlS4iLcbdprk6Xu",
    hoverClass: "spotify-hover",
  },
  {
    icon: "fab fa-youtube fa-2x",
    link:"https://www.youtube.com/channel/UCA_oIWOFu3x7LywkNdEa0vQ",
    hoverClass: "youtube-hover",
  },
  {
    icon: "fab fa-github fa-2x",
    link: "https://github.com/Kabishbrt",
    hoverClass: "github-hover",
  },
  {
    icon: "fab fa-linkedin-in fa-2x",
    link: "https://www.linkedin.com/in/kabish-bhattarai-9ab669190/",
    hoverClass: "linkedin-hover",
  },
  {
    icon: "fab fa-facebook-f fa-2x",
    link: "https://www.facebook.com/iamkabishb/",
    hoverClass: "fb-hover",
  },
  {
    icon: "fab fa-instagram fa-2x",
    link: "https://www.instagram.com/iamkabishb/",
    hoverClass: "insta-hover",
  },
  {
    icon: "fab fa-twitter fa-2x",
    link: "https://twitter.com/iamkabishb",
    hoverClass: "twitter-hover",
  },
];

const Footer = () => (
  <div
    className="container-fluid mt-5 footer d-block sticky-bottom aos-removal-class"
    data-aos="fade-up"
    data-aos-duration="1000"
  >
    <div className="container py-5 px-4">
      <div className="row">
        <div className="col-lg-8">
          <h2 className="fs-2 fw-bold">
            Connect With Me at
          </h2>
          <a
            className="email"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=kabishbrt@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
          kabishbrt@gmail.com
          </a>

          <ul className="social-icons list-unstyled d-flex flex-wrap w-100 justify-content-between align-items-center mt-5">
            {socialMediaInformation.map((item, index) => (
              <SocialMediaIcons
                icon={item.icon}
                link={item.link}
                hoverClass={item.hoverClass}
                key={index}
              />
            ))}
          </ul>

          <div className="copy fw-bold mt-5">
            © {new Date().getFullYear()}, Developed by &nbsp;
            <a href="https://kabishbhattarai.com.np/">Kabish Bhattarai</a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const SocialMediaIcons = ({ icon, link, hoverClass }) => (
  <li>
    <a href={link} target="_blank" rel="noreferrer">
      <i className={`${icon} footer-icon ${hoverClass}`}></i>
    </a>
  </li>
);

const dataAOSremoval = () => {
  /// For AOS Removal
  const aosRemovalSection =
    document.getElementsByClassName("aos-removal-class");

  aosRemovalSection &&
    Object.keys(aosRemovalSection).forEach((key, index) => {
      if (aosRemovalSection[key].hasAttribute("data-aos")) {
        aosRemovalSection[key].removeAttribute("data-aos");
      }
    });
};

export default CommonComponent;
